/* Smooth scroll init (Lenis).
   Deliberately conservative: disabled for reduced-motion users, on touch
   devices (native momentum is better there), and it never intercepts
   anchor/in-page links so checkout and skip-links keep working. */
(function () {
  'use strict';

  function start() {
    if (typeof window.Lenis !== 'function') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(pointer: coarse)').matches) return;

    var lenis = new window.Lenis({
      duration: 0.9,
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      smoothWheel: true,
      syncTouch: false
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    // In-page links must still jump correctly
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href');
      if (!id || id === '#') return;
      var target = document.querySelector(id);
      if (target) { e.preventDefault(); lenis.scrollTo(target); }
    });

    // Theme editor and drawers can lock scrolling; respect that
    document.addEventListener('shopify:section:load', function () { lenis.resize(); });
    window.__tsLenis = lenis;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else { start(); }
})();
